import React from 'react';
import TableHeader from './TableHeader';
import RecentUsersTableBody from './RecentUsersTableBody';
import { Table } from 'react-bootstrap';
import classes from '../index.module.scss';

const QuickStatsTableContainer = ({ users, header_list, searchTrigger, setSearchTrigger }) => {
  return (
    <Table striped responsive className={`${classes.Table} mb-4`}>
      <thead className={classes.Table_Head}>
        <TableHeader 
          list={header_list}
        />
      </thead>
      <tbody className={classes.Table_Body}>
        <RecentUsersTableBody 
          list={users} 
          searchTrigger={searchTrigger} 
          setSearchTrigger={setSearchTrigger}
        />
      </tbody>
    </Table>
  )
}

export default QuickStatsTableContainer;